import { AgGridModule } from '@ag-grid-community/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GridHeaderComponent } from '@components/grid-header/grid-header.component';
import { GridTemplateRendererComponent } from '@components/grid-template-renderer/grid-template-renderer.component';
import { TankFiltersComponent } from '@components/tank-filters/tank-filters.component';
import { TankGridAlarmRendererComponent } from '@components/tank-grid-alarm-renderer/tank-grid-alarm-renderer.component';
import { TankMapCardComponent } from '@components/tank-map-card/tank-map-card.component';
import { PhotoCarouselComponent } from '@components/photo-carousel/photo-carousel.component';
import { TankMapComponent } from '@components/tank-map/tank-map.component';
import { TankNotificationRendererComponent } from '@components/tank-notification-renderer/tank-notification-renderer.component';
import { TranslateModule } from '@ngx-translate/core';
import { AgChartsAngularModule } from 'ag-charts-angular';
import { AngularResizeEventModule } from 'angular-resize-event';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TooltipModule } from 'ng2-tooltip-directive';
import { ChartingModule } from 'src/app/modules/charting/charting.module';
import { GlobalSearchFilterComponent } from 'src/app/page/tank/tank-grid/global-search-filter.component';
import { TankGridAlarmTooltipComponent } from 'src/app/tooltip/tank-grid-alarm-tooltip/tank-grid-alarm-tooltip.component';
import { MaterialElevationDirective } from 'src/app/utilities/material-elevation.directive';
import { SiteUsageTrackerDirective } from 'src/app/utilities/siteUsageTracker';
import { MaterialModule } from '../../material.module';
import { TankNotificationItemRendererComponent } from '../../page/tanknotifications/components/tank-notification-item-renderer/tank-notification-item-renderer.component';
import { TankNotificationTooltipComponent } from '../../tooltip/tank-notification-tooltip/tank-notification-tooltip.component';
import { AnalyticWidgetDirective } from '../../utilities/analytic-widget.directive';
import { AuthorizationDirective } from '../../utilities/authorization.directive';
import { AnomalyNotificationsTreemapChartComponent } from '../../widget/anomaly-notifications-treemap-chart/anomaly-notifications-treemap-chart.component';
import { LocationAnomalyChartComponent } from '../../widget/location-anomaly-chart/location-anomaly-chart.component';
import { SyncfusionModule } from './syncfusion.module';
import { AdvancedDropdownComponent } from '../components/advanced-dropdown/advanced-dropdown.component';
import { SelectSearchComponent } from '../components/select-search/select-search.component';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { _buttonBaseComponent } from '@components/_button-base/_button-base.component';
import { AddressFormFieldComponent } from '@components/address-form-field/address-form-field.component';
import { AlarmEmailFormComponent } from '@components/alarm-email-form/alarm-email-form.component';
import { ClientTankListDialogComponent } from '@components/client-tank-list-dialog/client-tank-list-dialog.component';
import { CommonFormContainerComponent } from '@components/common-form-container/common-form-container.component';
import { PageFormShellComponent } from '@components/page-form-shell/page-form-shell.component';
import { DropdownFormFieldComponent } from '@components/dropdown-form-field/dropdown-form-field.component';
import { UserOptionComponent } from '@components/user-option/user-option.component';
import { DualTreeViewComponent } from '@components/dual-treeview/dual-treeview.component';
import { ExplicitConfirmationComponent } from '@components/explicit-confirmation/explicit-confirmation.component';
import { ExportToExcelButtonComponent } from '@components/export-to-excel-button/export-to-excel-button.component';
import { InfoPanelComponent } from '@components/info-panel/info-panel.component';
import {
  LinkWithPopupComponent,
  LinkWithPopupContentComponent,
} from '@components/link-with-pop-up/link-with-pop-up.component';
import { LocationFormFieldComponent } from '@components/location-form-field/location-form-field.component';
import { MinRtuLookupFieldComponent } from '@components/min-rtu-lookup-field/min-rtu-lookup-field.component';
import { MoveToLocationFormComponent } from '@components/move-to-location-form/move-to-location-form.component';
import { MoveToOrganizationFormComponent } from '@components/move-to-organization-form/move-to-organization-form.component';
import { MoveToStatusComponent } from '@components/move-to-status/move-to-status.component';
import { MultiSelectExpansionFieldComponent } from '@components/multi-select-expansion-field/multi-select-expansion-field.component';
import { NewLocationFormComponent } from '@components/new-location-form/new-location-form.component';
import { OrganizationFormFieldComponent } from '@components/organization-form-field/organization-form-field.component';
import { PercentageGaugeComponent } from '@components/percentage-gauge/percentage-gauge.component';
import { ResetButtonComponent } from '@components/reset-button/reset-button.component';
import { ResetSaveButtonGroupComponent } from '@components/reset-save-button-group/reset-save-button-group.component';
import { SaveButtonComponent } from '@components/save-button/save-button.component';
import { TankFormFieldComponent } from '@components/tank-form-field/tank-form-field.component';
import { TapFormFieldComponent } from '@components/tap-form-field/tap-form-field.component';
import { UserFormFieldComponent } from '@components/user-form-field/user-form-field.component';
import { UserGroupSearchSelectComponent } from '@components/user-group-search-select/user-group-search-select.component';
import { ViewFilterProfileDetailsPopUpComponent } from '@components/view-filter-profile-details-pop-up/view-filter-profile-details-pop-up.component';
import { ViewModelCheckboxListComponent } from '@components/view-model-checkbox-list/view-model-checkbox-list.component';
import { ViewTankProfileDetailsPopUpComponent } from '@components/view-tank-profile-details-pop-up/view-tank-profile-details-pop-up.component';
import { WidgetLegendComponent } from '@components/widget-legend/widget-legend.component';
import { GeolocationFilterComponent } from '../../page/tank/tank-grid/geolocation-filter/geolocation-filter.component';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { ToJsonOrStringPipe } from '@utils/to-json-or-string.pipe';

import { NgxMatomoTrackerModule } from '@ngx-matomo/tracker';
import { MarkdownModule } from 'ngx-markdown';
import { TankFilterService } from 'src/app/services/tank-filter.service';
import { TankSetupService } from 'src/app/services/tank-setup.service';
import { UtilsService } from 'src/app/services/utils.service';
import { CamelCaseToNormalPipe } from 'src/app/utilities/camel-case-to-normal-pipe.pipe';
import { DateTimePipe } from 'src/app/utilities/dateUtilities';
import { DeliveryEfficiencyForecastingFormComponent } from '../../components/delivery-efficiency-forecasting/delivery-efficiency-forecasting-form.component';
import { DialogHeaderComponent } from '../components/dialog-header/dialog-header.component';
import { ProgressStepsComponent } from '../components/progress-steps/progress-steps.component';
import { FileUploaderComponent } from '../components/file-uploader/file-uploader.component';
import { OrgTreeViewComponents } from '../components/organization-tree-view/component';
import { NoDecimalDirective } from '../directives/no-decimal.directive';
import { HighlightSearchDirective } from '../directives/search-highlight.directive';
import { ClickOutsideDirective } from '../directives/click-outside.directive';
import { StatusAcronymTooltipComponent } from '@components/status-acronym-tooltip/status-acronym-tooltip.component';
import { FilterProfileDisplayComponent } from '@components/filter-profile-display/filter-profile-display.component';
import { DownloadButtonComponent } from '@components/download-excel-template-button/download-excel-template-button.component';
import { UploadExcelTemplateButtonComponent } from '@components/upload-excel-template-button/upload-excel-template-button.component';
import { ImportLocationsDialogComponent } from '@components/import-locations-dialog/import-locations-dialog.component';
import { MultiSelectLocationFormFieldComponent } from '@components/multi-select-location-form-field/multi-select-location-form-field.component';
import { MultiSelectTankFormFieldComponent } from '@components/multi-select-tank-form-field/multi-select-tank-form-field.component';
import { MultiSelectOrganizationFormFieldComponent } from '@components/multi-select-organization-form-field/multi-select-organization-form-field.component';
import { SkytankFilterComponent } from 'src/app/page/tank/tank-grid/skytank-filter/skytank-filter.component';
import { TankMoveButtonComponent } from 'src/app/modules/tank-move/components/tank-move-button/tank-move-button.component';
import { ActiveCheckboxHeaderComponent } from '@utils/active-checkbox-header';
import { ActiveCheckboxCellRendererComponent } from '@utils/active-checkbox-cell-renderer.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UnassignTankButtonComponent } from '../../components/unassign-tank-button/unassign-tank-button.component';
import { TapAlertComponent } from '@components/tap-alert/tap-alert.component';
import { ValuePercentFieldComponent } from '@components/value-percent-field/value-percent-field.component';
import { ReferenceDisplayFieldComponent } from '@components/reference-display-field/reference-display-field.component';

const components = [
  GridHeaderComponent,
  SiteUsageTrackerDirective,
  AuthorizationDirective,
  AnalyticWidgetDirective,
  GlobalSearchFilterComponent,
  GeolocationFilterComponent,
  TankNotificationRendererComponent,
  TankGridAlarmRendererComponent,
  TankNotificationTooltipComponent,
  TankGridAlarmTooltipComponent,
  LocationAnomalyChartComponent,
  AnomalyNotificationsTreemapChartComponent,
  MaterialElevationDirective,
  TankNotificationItemRendererComponent,
  GridTemplateRendererComponent,
  TankFiltersComponent,
  PercentageGaugeComponent,
  WidgetLegendComponent,
  TankMapComponent,
  TankMapCardComponent,
  PhotoCarouselComponent,
  InfoPanelComponent,
  CommonFormContainerComponent,
  PageFormShellComponent,
  TapFormFieldComponent,
  MoveToLocationFormComponent,
  MoveToOrganizationFormComponent,
  MoveToStatusComponent,
  NewLocationFormComponent,
  DateTimePipe,
  ExplicitConfirmationComponent,
  CamelCaseToNormalPipe,
  ExportToExcelButtonComponent,
  UserFormFieldComponent,
  UserGroupSearchSelectComponent,
  AddressFormFieldComponent,
  MultiSelectExpansionFieldComponent,
  FileUploaderComponent,
  ResetSaveButtonGroupComponent,
  ResetButtonComponent,
  SaveButtonComponent,
  _buttonBaseComponent,
  ViewModelCheckboxListComponent,
  NoDecimalDirective,
  HighlightSearchDirective,
  ClickOutsideDirective,
  DialogHeaderComponent,
  ProgressStepsComponent,
  ...OrgTreeViewComponents,
  OrganizationFormFieldComponent,
  LocationFormFieldComponent,
  TankFormFieldComponent,
  MinRtuLookupFieldComponent,
  DeliveryEfficiencyForecastingFormComponent,
  AlarmEmailFormComponent,
  DropdownFormFieldComponent,
  UserOptionComponent,
  ToJsonOrStringPipe,
  DualTreeViewComponent,
  ViewFilterProfileDetailsPopUpComponent,
  ViewTankProfileDetailsPopUpComponent,
  LinkWithPopupContentComponent,
  LinkWithPopupComponent,
  ClientTankListDialogComponent,
  TankMoveButtonComponent,
  UnassignTankButtonComponent,
  StatusAcronymTooltipComponent,
  AdvancedDropdownComponent,
  SelectSearchComponent,
  FilterProfileDisplayComponent,
  DownloadButtonComponent,
  UploadExcelTemplateButtonComponent,
  ImportLocationsDialogComponent,
  MultiSelectLocationFormFieldComponent,
  MultiSelectTankFormFieldComponent,
  MultiSelectOrganizationFormFieldComponent,
  SkytankFilterComponent,
  ActiveCheckboxHeaderComponent,
  ActiveCheckboxCellRendererComponent,
  TapAlertComponent,
  ValuePercentFieldComponent,
  ReferenceDisplayFieldComponent,
];

@NgModule({
  imports: [
    ScrollingModule,
    OverlayModule,
    TreeViewModule,
    CommonModule,
    RouterModule,
    HttpClientModule,
    FlexLayoutModule,
    AngularResizeEventModule,
    NgxMatomoTrackerModule,
    SyncfusionModule,
    MaterialModule,
    MatButtonToggleModule,
    TooltipModule,
    AgChartsAngularModule,
    FormsModule,
    AngularSvgIconModule,
    //AgGridModule,
    AgGridModule,
    ReactiveFormsModule,
    DragDropModule,
    // Plain, not forChild(): every module shares the root TranslateService, its catalog loader and
    // its uppercasing (app.module.ts). forChild() would give each lazy module its own instance.
    TranslateModule,
    ChartingModule,
    MarkdownModule.forRoot(),
    MatCheckboxModule
  ],
  declarations: components,
  exports: [
    ScrollingModule,
    OverlayModule,
    CommonModule,
    HttpClientModule,
    RouterModule,
    AgGridModule,
    MaterialModule,
    SyncfusionModule,
    NgxMatomoTrackerModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    AngularSvgIconModule,
    TooltipModule,
    FormsModule,
    DragDropModule,
    AngularResizeEventModule,
    AgChartsAngularModule,
    TranslateModule,
    ChartingModule,
    ...components,
    MarkdownModule,
  ],
  providers: [
    UtilsService,
    TankSetupService,
    TankFilterService,
  ],
})
export class SharedModule {
  constructor() {}
}
